import { IEsfCoverageIn } from "../../models/input/generalApi/IEsfCoverageIn";
import * as ApiWithToken from "../callApiWithToken";

const esfCoverageService = {
    getEsfCoverage: async function () {
        return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `Sync/GetEsfCoverage`);
    },
    getEsfCoverageLov: async function () {
        return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `Sync/GetEsfCoverageLov`);
    },
    getEsfCoverageType: async function (languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `Sync/GetEsfCoverageTypeWeb?LanguageID=${languageId}`);
    },
    insertEsfCoverage:async function(esfCoverageIn: IEsfCoverageIn[]){
        return ApiWithToken.postApi(process.env.REACT_APP_GENERAL_API + `Sync/EsfCoverageInsert`, esfCoverageIn);
    },
}

export default esfCoverageService;